const permissions = {
  PRIVATE_INVITATION: 'Private Invitation',
  ALL: 'All',
  PUBLIC: 'Public',
  VIP: 'VIP'
}

export default permissions
